// Constants
import {
  REL_KEY_PARAM,
  VIMEO_REGEX,
  YOUTUBE_REGEX,
  YOUTUBE_REL_VALUE,
} from '@/common/constants';

const getVideoSrc = (src) => {
  let newSrc = src;

  if (src.match(VIMEO_REGEX)) {
    const id = src.match(VIMEO_REGEX)[1];

    newSrc = `https://player.vimeo.com/video/${id}`;
  } else if (src.match(YOUTUBE_REGEX)) {
    const id = src.match(YOUTUBE_REGEX)[2];

    newSrc = `https://www.youtube.com/embed/${id}?${REL_KEY_PARAM}=${YOUTUBE_REL_VALUE}`;
  }

  return newSrc;
};

export default getVideoSrc;
